import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileUp, Watch } from "lucide-react";
import HealthReportDialog from "./HealthReportDialog";

/**
 * "Bring your own health data" banner — the SINGLE upload entry point on the
 * Longevity Overview page. One button for every report type; the AI identifies
 * what was uploaded and routes it to the right card.
 */
export const HealthScreenshotCard = ({ onSave }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Card className="rounded-2xl mb-5 border-primary/20 bg-primary/5" data-testid="biometric-wearable-card">
        <CardContent className="p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-2">
              <Watch className="w-4 h-4 text-primary" />
              <p className="text-sm font-medium">Bring your own health data</p>
            </div>
            <p className="text-xs text-muted-foreground">
              Upload any health report — a HOWBODY body composition sheet, a MEICET / VISIA skin analysis
              report, a screenshot from Google Health, Apple Health or Fitbit, or a lab result. We'll
              recognise it, read the values and let you check each one before it's saved.
            </p>
          </div>
          <Button
            size="sm"
            variant="outline"
            className="rounded-full flex-shrink-0 bg-background"
            onClick={() => setOpen(true)}
            data-testid="biometric-upload-health-report-btn"
          >
            <FileUp className="w-3.5 h-3.5 mr-1.5" /> Upload Health Report
          </Button>
        </CardContent>
      </Card>
      <HealthReportDialog open={open} onOpenChange={setOpen} onSaveVault={onSave} />
    </>
  );
};

export default HealthScreenshotCard;
